import { Fragment, useState, useCallback } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { fetchAPI } from '../../../api/request';
import { useSelector } from 'react-redux';
import ConfirmDialog from '../../common/Confirm.component';
import Loading from '../../common/Loading.component';
import DeleteIcon from '@mui/icons-material/Delete';
import Alert from '../../common/Alert.component';

const DeleteItem = ({ module, handleSuccess = () => {}, item }) => {
  const { query } = module;

  const { jwt } = useSelector((state) => state.login);
  const [idDeleted, setIdDeleted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleClose = useCallback(() => {
    setOpen(false);
    setIdDeleted(null);
  }, []);

  const handleOpen = useCallback((item) => {
    setOpen(true);
    setIdDeleted(item);
  }, []);

  const onSuccess = useCallback(() => {
    setSuccess(true);
    setLoading(false);
    handleClose();
  },[handleClose])

  const onError = useCallback(
    (err) => {
      setLoading(false);
      setError(err);
    },
    [setLoading, setError]
  );

  const onDeleteAction = useCallback(() => {
    handleSuccess(false);
    fetchAPI(query.delete.settings, { id: idDeleted }, '', {}, jwt)
      .then(() => {
        onSuccess();
        handleSuccess((prev) => !prev);
      })
      .catch(onError);
  }, [handleSuccess, onSuccess, jwt, onError, idDeleted, query]);

  return (
    <Fragment>
      {loading && <Loading />}
      {success && <Alert severity='success'>{'Success!!'}</Alert>}

      {error && (
        <Alert severity='error'>
          {error?.response?.data?.error?.message || 'An error has occurred'}
        </Alert>
      )}

      <Tooltip title='DELETE'>
        <IconButton color='error' onClick={() => handleOpen(item?.id)}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>

      <ConfirmDialog
        open={open}
        onClose={handleClose}
        title='Are you sure you want to delete this?'
        description='It will be deleted permanently. You cannot undo this action.'
        cancelAction={handleClose}
        confirmAction={onDeleteAction}
      />
    </Fragment>
  );
};
export default DeleteItem;
